import * as React from 'react';
import { history } from 'kts-platform-frame/routes';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { document, createCompany } from 'src/api';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { message, Row, Col } from 'antd';

const css = require('./index.scss');

class ModulesAction extends ActionBasic<ModulesState> {
    /**
     * 保存 文件id
     */
    public saveId = (id: string, recordSearch: any) => {
        this.modulesState.recordSearch = recordSearch;
        this.modulesState.documentUUID = id;
        this.setModulesState(this.modulesState, () => {
            this.getData();
            this.getStatus();
            this.getCountry();
            this.allowedDocType();
            this.documentInfoGet();
        });
    }
    /**
     * 获取可 转换的 单据
     */
    public allowedDocType = async () => {
        const param = {
            uuid: this.modulesState.documentUUID,
        };
        const reData = await document.allowedDocType(this, param);
        if (!reData.er) {
            this.modulesState.allowedDocType = reData.res.list;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 文档类型转换 
     */
    public documentTransform = async (docType: string) => {
        const param = {
            documentUUID: this.modulesState.documentUUID,
            toDocType: docType,
        };
        const reData = await document.documentTransform(this, param);
        this.modulesState.selectBillTypeM = false;
        this.setModulesState(this.modulesState);
        if (!reData.er) {
            history.push(`/workbench/platform/document/editDocument/${docType}/${reData.res.documentUUID}`);
        }
    }
    /**
     * 查询单据 是否已归档
     */
    public documentInfoGet = async () => {
        const param = {
            uuid: this.modulesState.documentUUID,
        };
        const reData = await document.documentInfoGet(this, param);
        if (!reData.er) {
            this.modulesState.isArchived = reData.res.isArchived;
            this.modulesState.allowedTargetStatus = reData.res.allowedTargetStatus;
            this.modulesState.isSenderParty = reData.res.isSenderParty;
            this.setModulesState(this.modulesState);
        }
    }
    /**
     * 更改归档状态
     */
    public documentArchive = async () => {
        const param = {
            documentUUID: this.modulesState.documentUUID,
            archive: !this.modulesState.isArchived,
        };
        const reData = await document.documentArchive(this, param);
        if (!reData.er) {
            message.success("操作成功");
            this.documentInfoGet();
        } else {
            message.error("操作失败");
        }
    }
    /**
     * 返回首页
     */
    public goBack = () => {
        history.goBack();
    }
    /**
     * 分页设置
     */
    public pageSet = (page: number, pageSize: number) => {
        if (pageSize !== this.modulesState.pageSize || page === 0) {
            this.modulesState.pageNum = 1;
        } else {
            this.modulesState.pageNum = page;
        }
        this.modulesState.pageSize = pageSize;
        this.setModulesState(this.modulesState, () => {
            this.getData();
        });
    }
    /**
     * 获取单据状态
     */
    public getStatus = async () => {
        const param = {
            uuid: this.modulesState.documentUUID,
        };
        const reData = await document.documentStatusGet(this, param);
        if (!reData.er) {
            this.modulesState.documentStatus = reData.res.status;
            this.setModulesState(this.modulesState);
        } else {
            this.goBack();
        }

    }
    /**
     * 获取数据
     */
    public getData = async () => {
        const param = {
            uuid: this.modulesState.documentUUID,
            pageNum: this.modulesState.pageNum,
            pageSize: this.modulesState.pageSize,
        };
        this.modulesState.documentInfo.Lines = [];
        this.setModulesState(this.modulesState);
        const reData: any = await document.documentGet(this, param);
        if (!reData.er) {

            this.modulesState.total = reData.res.pageMeta.total;
            this.modulesState.pageNum = reData.res.pageMeta.pageNum;
            this.modulesState.pageSize = reData.res.pageMeta.pageSize;
            this.modulesState.documentType = reData.res.items[0].doc.DocumentType;
            switch (reData.res.items[0].doc.DocumentType) {
                case 'Order':
                    // 订单名称
                    this.modulesState.documentInfo = reData.res.items[0].doc;
                    this.modulesState.billType = this.modulesState.documentInfo.DocumentType;
                    // 表格数据
                    this.modulesState.tableList = this.modulesState.documentInfo.Lines;
                    break;
                case 'Contract':
                    // 订单名称
                    this.modulesState.ContractForm = reData.res.items[0].doc;
                    this.modulesState.billType = this.modulesState.ContractForm.DocumentType;
                    // 表格数据
                    this.modulesState.tableList = this.modulesState.ContractForm.Lines;
                    break;
                case 'ForecastDemand':
                case 'ForecastPrediction':
                    // 计划单
                    this.modulesState.forecastForm = reData.res.items[0].doc;
                    this.modulesState.billType = this.modulesState.forecastForm.DocumentType;
                    // 表格数据
                    this.modulesState.tableList = this.modulesState.forecastForm.Lines;
                    break;
                case 'DespatchAdvice':
                    // 发货单
                    this.modulesState.despatchAdviceForm = reData.res.items[0].doc;
                    this.modulesState.billType = this.modulesState.despatchAdviceForm.DocumentType;
                    // 表格数据
                    this.modulesState.tableList = this.modulesState.despatchAdviceForm.Lines;
                    break;
                case 'ReceiptAdvice':
                case 'ReceiptAdviceRATC01':
                case 'ReceiptAdviceReturn':
                    // 收货单
                    this.modulesState.receiptAdviceForm = reData.res.items[0].doc;
                    this.modulesState.billType = this.modulesState.receiptAdviceForm.DocumentType;
                    // 表格数据
                    this.modulesState.tableList = this.modulesState.receiptAdviceForm.Lines;
                    break;
                case 'StockInNotice':
                    // 入库单
                    this.modulesState.stockInNoticeForm = reData.res.items[0].doc;
                    this.modulesState.billType = this.modulesState.stockInNoticeForm.DocumentType;
                    // 表格数据
                    this.modulesState.tableList = this.modulesState.stockInNoticeForm.Lines;
                    break;
                default:
                    break;
            }
            // 单据规则
            this.modulesState.rules = reData.res.items[0].rules;
            this.setModulesState(this.modulesState);
        } else {
            this.goBack();
        }

    }
    /** 转换单据 弹框打开/关闭 */
    public changeBillTypeM = () => {
        this.modulesState.selectBillTypeM = !this.modulesState.selectBillTypeM;
        if (this.modulesState.selectBillTypeM) {
            this.modulesState.createBillType = '';
        }
        this.setModulesState(this.modulesState);
    }
    /** 转换单据 选择类型 */
    public billTypeChoose = (name: string) => {
        if (name === this.modulesState.createBillType) {
            this.modulesState.createBillType = '';
        } else {
            this.modulesState.createBillType = name;
        }
        this.setModulesState(this.modulesState);
    }
    /** 获取国家列表 */
    public getCountry = async () => {
        const res = await createCompany.country(this, null);
        if (!res.er) {
            this.modulesState.countryList = res.res.countryList;
            this.setModulesState();
        }
    }
    /** 拒绝 弹框打开/关闭 */
    public refuseM = (refuseType?: string) => {
        this.modulesState.refuseType = refuseType ? refuseType : '';
        this.modulesState.refuseInputNum = 0;
        this.modulesState.refuseM = !this.modulesState.refuseM;
        this.setModulesState(this.modulesState);
    }
    /** 拒绝理由验证长度 */
    public checkLength = (e: any) => {
        this.modulesState.refuseInputNum = e.target.value.length;
        this.setModulesState(this.modulesState);
    }
    /**
     * 更新文档状态
     */
    public updataDocumentStatus = async (status: string, content?: string) => {
        const param = {
            documentUUID: this.modulesState.documentUUID,
            status: status,
            message: content,
        };
        const reData = await document.documentStatusUpdate(this, param);
        if (!reData.er) {
            message.success("操作成功");
            this.getData();
            this.getStatus();
            this.allowedDocType();
            this.documentInfoGet();
        }
    }
    /** 发送文档 */
    public documentSend = async () => {
        const param = {
            documentUUID: this.modulesState.documentUUID,
        };
        const reData = await document.documentSend(this, param);
        if (!reData.er) {
            message.success("发送成功");
            this.getData();
        }
    }
    /**
     * base64转数组
     */
    public base64ToArrayBuffer = (base64) => {
        let binaryString = window.atob(base64);
        let len = binaryString.length;
        let bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }
    /**
     * 下载查看文件
     */
    public documentAttachmentGet = async (uuid: string) => {
        const res = await document.documentAttachmentGet(this, { uuid: uuid });
        if (!res.er) {
            let debug = this.base64ToArrayBuffer(res.res.base64Content);
            let blob = new Blob([debug], { type: res.res.mimeType });
            let data = blob;
            let a = window.document.createElement('a');
            let url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = res.res.fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }
    /**
     * 获取行自定义字段 显示模板
     * @param rowData 表格line一行 数据
     * @param colspan col样式 默认7
     */
    public getTableExtraTemplate = (rowData, colspan = 7) => {
        const lineRules = this.modulesState.rules.Lines.Extra;
        let template = [];
        for (let keyName of Object.keys(lineRules)) {
            if (lineRules[keyName].type === 2) {  // 自定义
                template.push(
                    <Col span={colspan} className={css.Extraline} key={keyName}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>{lineRules[keyName]['displayText']}</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {this.extraTypeVal(lineRules[keyName], rowData[keyName])}
                            </span>
                        </Col>
                    </Col>
                );
            }
        }
        return template;
    }

    /**
     * 获取系统字段(来源单据/来源单据行/描述) 显示模板
     * @param rowData 表格line一行 数据
     * @param colspan col样式 默认8
     */
    public getTableExtraDefaultTemplate = (record, colspan = 8) => {
        const docType = this.modulesState.documentType;

        let template = (
            <div>
                {docType !== 'DespatchAdvice' && <div>
                    <Col span={colspan} className={css.Extraline}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>销售商品编号</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {record.SellersItemIdentification}
                            </span>
                        </Col>
                    </Col>
                    <Col span={colspan} className={css.Extraline}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>销售商品名称</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {record.SellersItemName}
                            </span>
                        </Col>
                    </Col>
                    <Col span={colspan} className={css.Extraline}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>销售规格/型号</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {record.SellersItemModelName}
                            </span>
                        </Col>
                    </Col>
                </div>}
                {docType === 'DespatchAdvice' && <div>
                    <Col span={colspan} className={css.Extraline}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>采购商品编号</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {record.BuyersItemIdentification}
                            </span>
                        </Col>
                    </Col>
                    <Col span={colspan} className={css.Extraline}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>采购商品名称</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {record.BuyersItemName}
                            </span>
                        </Col>
                    </Col>
                    <Col span={colspan} className={css.Extraline}>
                        <Col span={7}>
                            <span className={css.titleExtraName}>采购规格型号</span>
                        </Col>
                        <Col span={17}>
                            <span className={css.infoExtra}>
                                {record.BuyersItemModelName}
                            </span>
                        </Col>
                    </Col>
                </div>}
                <Col span={colspan} className={css.Extraline}>
                    <Col span={7}>
                        <span className={css.titleExtraName}>来源单据</span>
                    </Col>
                    <Col span={17}>
                        <span className={css.infoExtra}>
                            {record.DocumentReference}
                        </span>
                    </Col>
                </Col>
                <Col span={colspan} className={css.Extraline}>
                    <Col span={7}>
                        <span className={css.titleExtraName}>来源单据行</span>
                    </Col>
                    <Col span={17}>
                        <span className={css.infoExtra}>
                            {record.LineReference}
                        </span>
                    </Col>
                </Col>
                <Col span={colspan} className={css.Extraline}>
                    <Col span={7}>
                        <span className={css.titleExtraName}>描述</span>
                    </Col>
                    <Col span={17}>
                        <span className={css.infoExtra}>
                            {record.Description}
                        </span>
                    </Col>
                </Col>
            </div>
        );
        return template;
    }

    /**
     * 单据添加自定义 字段 
     * @param documentInfo 单据信息
     */
    public getExtraTemplate = (documentInfo) => {
        const rules = this.modulesState.rules.Extra;
        let template = [];
        for (let keyName of Object.keys(rules)) {
            if(rules[keyName].type === 2){  // 自定义字段
                template.push(
                    <Row key={keyName}>
                        <Col span={5}>
                            <span className={css.titleName}>{rules[keyName]['displayText']}</span>
                        </Col>
                        <Col span={19}>
                            <div className={css.info}>
                                {this.extraTypeVal(rules[keyName], documentInfo[keyName])}
                            </div>
                        </Col>
                    </Row>
                );
            }
        }
        return template;
    }

    /**
     * 自定义字段 根据不同类型 获取不同值
     */
    public extraTypeVal = (rules, data) => {
        let val = data;
        switch (rules.inputType) {
            case 'TEXT':
                val = data;
                break;
            case 'SELECT':
                let filterData = Array.isArray(rules.selectOptions) ? rules.selectOptions.filter((item) => {
                    return item.val === data;
                }) : [];
                val = filterData.length ? filterData[0].key : data;
                break;
            case 'DATE':
                val = data && !isNaN(data) ? Field.formatDate(Number(data)) : data;
                break;
            case 'DATETIME':
                val = data && !isNaN(data) ? Field.formatTime(Number(data)) : data;
                break;
            default:
                break;
        }
        return val;
    }
    /**
     * 获取展开行的 key
     */
    public getRowKey = () => {
        let tableData = this.modulesState.tableList;
        let rowKeyArr = [];
        tableData.forEach((el, index) => {
            rowKeyArr.push(index + ((this.modulesState.pageNum - 1) * this.modulesState.pageSize));
        });
        return rowKeyArr;
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/Modules.Action.tsx